import heartbeat from "@volumental/assets/icons/heartbeat.svg";
import { Text } from "@volumental/common";
import type React from "react";
import { useEffect } from "react";
import { Popup } from "./popup";

const heartbeatTime = 2000;

interface PopupProps {
  close: () => void;
  show: boolean;
  messageText: string;
  desciption?: string;
}

export function ThankYouPopup({ close, show, messageText, desciption }: PopupProps): React.JSX.Element {
  useEffect(() => {
    if (show) {
      setTimeout(close, heartbeatTime);
    }
  }, [show, close]);
  return (
    <Popup show={show} fixAspect>
      <div className="flex flex-col justify-center items-center text-center self-center justify-self-center mx-6 mb-6">
        <img src={heartbeat} alt={messageText} />
        <Text className="font-bold text-2xl">{messageText}</Text>
        <Text>{desciption}</Text>
      </div>
    </Popup>
  );
}
